export default {
  "contract_name": "Tiles",
  "abi": [
    {
      "constant": true,
      "inputs": [],
      "name": "gameStopped",
      "outputs": [
        {
          "name": "",
          "type": "bool"
        }
      ],
      "payable": false,
      "type": "function"
    },
    {
      "constant": true,
      "inputs": [],
      "name": "numTilesClaimed",
      "outputs": [
        {
          "name": "",
          "type": "uint256"
        }
      ],
      "payable": false,
      "type": "function"
    },
    {
      "constant": false,
      "inputs": [],
      "name": "cancelContract",
      "outputs": [
        {
          "name": "",
          "type": "bool"
        }
      ],
      "payable": false,
      "type": "function"
    },
    {
      "constant": true,
      "inputs": [],
      "name": "currentGameBalance",
      "outputs": [
        {
          "name": "",
          "type": "uint256"
        }
      ],
      "payable": false,
      "type": "function"
    },
    {
      "constant": true,
      "inputs": [],
      "name": "NUM_TILES",
      "outputs": [
        {
          "name": "",
          "type": "uint256"
        }
      ],
      "payable": false,
      "type": "function"
    },
    {
      "constant": true,
      "inputs": [],
      "name": "DEFAULT_GAME_COST",
      "outputs": [
        {
          "name": "",
          "type": "uint256"
        }
      ],
      "payable": false,
      "type": "function"
    },
    {
      "constant": false,
      "inputs": [],
      "name": "claimOwnersEarnings",
      "outputs": [],
      "payable": false,
      "type": "function"
    },
    {
      "constant": true,
      "inputs": [
        {
          "name": "",
          "type": "uint256"
        },
        {
          "name": "",
          "type": "uint256"
        }
      ],
      "name": "tiles",
      "outputs": [
        {
          "name": "gameClaimed",
          "type": "uint256"
        },
        {
          "name": "claimedBy",
          "type": "address"
        }
      ],
      "payable": false,
      "type": "function"
    },
    {
      "constant": true,
      "inputs": [],
      "name": "willChangeCost",
      "outputs": [
        {
          "name": "",
          "type": "bool"
        }
      ],
      "payable": false,
      "type": "function"
    },
    {
      "constant": true,
      "inputs": [],
      "name": "currentGameNumber",
      "outputs": [
        {
          "name": "",
          "type": "uint256"
        }
      ],
      "payable": false,
      "type": "function"
    },
    {
      "constant": false,
      "inputs": [],
      "name": "claimWinnings",
      "outputs": [],
      "payable": false,
      "type": "function"
    },
    {
      "constant": false,
      "inputs": [
        {
          "name": "xCoord",
          "type": "uint256"
        },
        {
          "name": "yCoord",
          "type": "uint256"
        },
        {
          "name": "gameNumber",
          "type": "uint256"
        }
      ],
      "name": "claimTile",
      "outputs": [],
      "payable": true,
      "type": "function"
    },
    {
      "constant": false,
      "inputs": [
        {
          "name": "newGameCost",
          "type": "uint256"
        }
      ],
      "name": "updateGameCost",
      "outputs": [
        {
          "name": "",
          "type": "bool"
        }
      ],
      "payable": false,
      "type": "function"
    },
    {
      "constant": true,
      "inputs": [],
      "name": "currentGameCost",
      "outputs": [
        {
          "name": "",
          "type": "uint256"
        }
      ],
      "payable": false,
      "type": "function"
    },
    {
      "constant": true,
      "inputs": [],
      "name": "gameEarnings",
      "outputs": [
        {
          "name": "",
          "type": "uint256"
        }
      ],
      "payable": false,
      "type": "function"
    },
    {
      "constant": true,
      "inputs": [
        {
          "name": "",
          "type": "uint256"
        }
      ],
      "name": "gameToWinner",
      "outputs": [
        {
          "name": "",
          "type": "address"
        }
      ],
      "payable": false,
      "type": "function"
    },
    {
      "constant": true,
      "inputs": [],
      "name": "nextGameCost",
      "outputs": [
        {
          "name": "",
          "type": "uint256"
        }
      ],
      "payable": false,
      "type": "function"
    },
    {
      "constant": true,
      "inputs": [
        {
          "name": "",
          "type": "address"
        }
      ],
      "name": "pendingWithdrawals",
      "outputs": [
        {
          "name": "",
          "type": "uint256"
        }
      ],
      "payable": false,
      "type": "function"
    },
    {
      "inputs": [],
      "payable": true,
      "type": "constructor"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "name": "gameNumber",
          "type": "uint256"
        },
        {
          "indexed": true,
          "name": "winner",
          "type": "address"
        }
      ],
      "name": "GameWon",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "name": "gameNumber",
          "type": "uint256"
        },
        {
          "indexed": true,
          "name": "xCoord",
          "type": "uint256"
        },
        {
          "indexed": true,
          "name": "yCoord",
          "type": "uint256"
        },
        {
          "indexed": false,
          "name": "claimedBy",
          "type": "address"
        }
      ],
      "name": "TileClaimed",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "name": "claimedBy",
          "type": "address"
        },
        {
          "indexed": true,
          "name": "amountClaimed",
          "type": "uint256"
        }
      ],
      "name": "WinningsClaimed",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "name": "claimedBy",
          "type": "address"
        },
        {
          "indexed": true,
          "name": "amountToClaim",
          "type": "uint256"
        }
      ],
      "name": "FailedToClaim",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "name": "hash",
          "type": "bytes32"
        },
        {
          "indexed": false,
          "name": "xCoord",
          "type": "uint256"
        },
        {
          "indexed": false,
          "name": "yCoord",
          "type": "uint256"
        }
      ],
      "name": "PrintWinningInfo",
      "type": "event"
    }
  ],
  "unlinked_binary": "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",
  "networks": {},
  "schema_version": "0.0.5",
  "updated_at": 1509417379296
}



// WEBPACK FOOTER //
// ./src/data/gameContract.js